import router from '@/router'
import checkPermission from '@/utils/permission'
import { Message } from '@/utils/Message'

export function permissionJump(routeName, routeTitle = '', routePermissions = null, routeParams = {}) {
  console.log('router start')
  if (routePermissions && !checkPermission(routePermissions)) {
    Message.error(`你没有打开【${routeTitle || routeName}】模块的权限`)
    return
  }
  router.push({ name: routeName, params: routeParams })
}
